import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { FullProfileDialogAnimationsEnum } from '../../Core/Dialogs/enums/full-profile-dialog-animations.enum';
import { FullProfileAnimationModel } from '../../Core/Dialogs/models/full-profile-animation.model';
import { OverlayAnimationStateEnum } from '../../Core/Dialogs/enums/overlay-animation.enum';
import { CoreDialogService } from '../../Core/Dialogs/services/dialog.service';
import { MonitoringSeriesTypeEnum } from '../../Monitor/Shared/enums/monitoring-series-type.enum';
import { MentionSearchCriteriaModel } from '../../Monitor/Shared/models/mention-search-criteria.model';
import { ManageSourceAgentsPanelComponent } from '../components/ManageSourceAgentsPanel/manage-source-agents-panel.component';

/**
 * Opens the panel listing the automation agents on one source. Rooted because the Add Live Agent
 * controls live wherever sources are listed - the monitoring results bar, the tag and social topic
 * dialogs, the theme cards - and they should all open the same panel the same way.
 */
@Injectable({ providedIn: 'root' })
export class ManageSourceAgentsService {

    constructor(private coreDialogService: CoreDialogService) {}

    /**
     * @param filterSearchCriteria the filters applied where the panel was opened from, carried on
     * to whatever agent is put on the source from it
     */
    open(
        sourceType: MonitoringSeriesTypeEnum,
        sourceId: number | string,
        filterSearchCriteria: MentionSearchCriteriaModel = null
    ): void {
        if (!sourceType || !sourceId) {
            return;
        }

        this.coreDialogService.open(ManageSourceAgentsPanelComponent, {
            inputs: {
                animationTrigger: new BehaviorSubject(
                    new FullProfileAnimationModel(
                        FullProfileDialogAnimationsEnum.slideInOutAnimation,
                        OverlayAnimationStateEnum.open
                    )
                ),
                overlayContainer: document.getElementById('main-content'),
                sourceType: sourceType,
                sourceId: Number(sourceId),
                filterSearchCriteria: filterSearchCriteria
            }
        });
    }
}
